import { render, staticRenderFns } from "./config-manage.vue?vue&type=template&id=11c8d11d&scoped=true"
import script from "./config-manage.vue?vue&type=script&lang=js"
export * from "./config-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c8d11d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c8d11d')) {
      api.createRecord('11c8d11d', component.options)
    } else {
      api.reload('11c8d11d', component.options)
    }
    module.hot.accept("./config-manage.vue?vue&type=template&id=11c8d11d&scoped=true", function () {
      api.rerender('11c8d11d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/config/config-manage.vue"
export default component.exports